import { RpmNoticeContentMock } from '../generated/mocks/RpmNoticeContentModelMock';
import { RpmNoticeContentModel } from '../generated/types/RpmNoticeContentModel';

const defaultRpmNoticeContentMock = RpmNoticeContentMock.rpm_notice[0] as unknown as RpmNoticeContentModel;

const exampleRpmNoticeContentMock: Partial<RpmNoticeContentModel> = {
  content_code: 'NOTICE_ID',
  page_title: 'Weight change',
};

const create = (partial?: Partial<RpmNoticeContentModel>): RpmNoticeContentModel => ({
  ...defaultRpmNoticeContentMock,
  ...exampleRpmNoticeContentMock,
  ...partial,
});

export const RpmNoticeContentModelMock = { create };
